import { useState } from 'react';
import NotificationContext from '../types/notificationContext';
import Notification from '../types/notification';

const useNotification = (): NotificationContext => {
    const [open, setOpen] = useState<boolean>(false);
    const [notification, setNotification] = useState<Notification>({
        title: '',
        message: '',
        severity: 'info',
    });

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const showNotification = ({ message, severity, title }: Notification) => {
        handleOpen();

        setNotification({
            message,
            severity,
            title,
        });
    };

    return {
        open,
        handleOpen,
        handleClose,
        notification,
        showNotification,
    };
};

export default useNotification;
